import { inject } from '@angular/core';
import type { ProjectReference } from '@indutrust/factory-model';
import { withCrudEntitiesEvents } from '@indutrust/shared-util';
import { signalStore } from '@ngrx/signals';
import { FactoryProjectReferenceApiClient } from '../factory-project-reference-api-client.service';
import { factoryProjectReferenceCrudEvents } from './factory-project-references.events';

/**
 * Component-scoped store for the factory-scoped `/project_references`
 * sub-resource.
 *
 * Provided by {@link import('@indutrust/factory-feature').FactoryEdit | FactoryEdit}
 * (or any feature that surfaces a single factory's references) so each
 * factory editor instance gets a fresh entity collection.
 *
 * Callers MUST pass `urlSegments: { factoryId }` to every CRUD method —
 * the wrapped {@link FactoryProjectReferenceApiClient} substitutes the
 * segment into the URL template before issuing the request.
 *
 * @example
 * readonly projectReferencesStore = inject(FactoryProjectReferencesStore);
 * this.projectReferencesStore.loadAll({ factoryId: 42 });
 */
export const FactoryProjectReferencesStore = signalStore(
  withCrudEntitiesEvents<ProjectReference>(
    factoryProjectReferenceCrudEvents,
    () => inject(FactoryProjectReferenceApiClient)
  )
);
